import App from 'app/app.js';
import 'app/store/MessageStore.js';
import 'app/store/RewardStore.js';
import 'app/action/LoginSuccessAction.js';
import 'app/action/DeserializeAction.js';
import 'app/service/StorageService.js';
import 'app/service/TranslateProviderService.js';
import 'app/service/AnalyticsService.js';
import '@app/service/HotjarSessionMappingService';
import 'app/service/IdentityService.js';
import 'app/action/ResetJobAction.js';
import 'app/action/JobLoadedAction.js';
import 'app/action/SessionTimeoutAction.js';
import 'app/action/LogoutSuccessAction.js';

function UserProfileStore(
  $http,
  BlockService,
  MessageStore,
  RewardStore,
  LoginSuccessAction,
  DeserializeAction,
  ResetJobAction,
  StorageService,
  TranslateProviderService,
  LogoutSuccessAction,
  JobLoadedAction,
  SessionTimeoutAction,
  $q,
  $rootScope,
  $timeout,
  JobStore,
  $anchorScroll,
  $location,
  $filter,
  $injector,
  IdentityService,
  SubjectStore,
  MasterSubjectService,
  PersistentCartService
) {
  this.userProfile = { enrollMe: false };
  this.initialUserProfile = {};
  this.guestUserProfile = {};
  var that = this;

  this.loadIdentityUser = function () {
    const { mlt_uid } = IdentityService.getCurrentUser() || {};

    if (!mlt_uid) {
      return this.loadLegacyUser();
    }

    BlockService.blockUI();

    return $http
      .post('./userProfile/loginIdentity')
      .then(({ data: response }) => {
        if (!response.success) {
          throw new Error(response.error?.code);
        }

        const userProfile = response.data.userProfile;
        this.setUserProfile({
          ...userProfile,
          isLoggedIn: true,
          isLoggedInWithIdentity: true
        });

        return this.reloadUserProfile();
      })
      .then(() => {
        BlockService.blockUI();
        return this.loadSubjects();
      })
      .catch((e) => {
        MessageStore.createForm('COMMON_TEXT_ERROR');

        throw e;
      })
      .finally(() => BlockService.unblockUI());
  };

  this.loadLegacyUser = function () {
    this.userProfile = StorageService.getData('userProfile') || {};
    if (!!this.userProfile && this.userProfile.isLoggedIn) {
      return this.reloadUserProfile();
    }
    return $q.resolve();
  };

  this.isUserLoggedInWithIdentity = function () {
    return !!this.userProfile.isLoggedInWithIdentity;
  };

  this.getInitialUserProfile = function () {
    return this.initialUserProfile;
  };

  this.setInitialUserProfile = function (initialUserProfile) {
    this.initialUserProfile = initialUserProfile;
  };

  this.setEnrollMe = function (enrollme) {
    this.userProfile.enrollMe = enrollme;
  };
  this.getEnrollMe = function () {
    return this.userProfile.enrollMe;
  };

  this.rewardProfile = {};

  this.reset = function () {
    this.userProfile = {};
    this.initialUserProfile = {};
    this.guestUserProfile = {};
    this.userProfile.isLoggedIn = false;
    $rootScope.checkIfLoggedIn = false;
    $rootScope.rewardLoaded = false;
    StorageService.setData('identityEmail', null);
    this.updateStorage();
    if (typeof Sentry !== 'undefined' && typeof Sentry.setUser === 'function') {
      Sentry.setUser(null);
    }
  };

  this.loadRewards = function () {
    var defer = $q.defer();
    var analyticsService = $injector.get('AnalyticsService');
    if (this.isLoggedIn()) {
      var result = RewardStore.getRewards().then(
        function (data) {
          $rootScope.rewardLoaded = true;
          this.userProfile.rewards = data;
          this.updateStorage();
          analyticsService.updateContentView();
          defer.resolve(result);
        }.bind(this)
      );
    } else {
      defer.resolve();
    }
    return defer.promise;
  };

  this.isLoggedIn = function () {
    return !!this.userProfile.isLoggedIn;
  };

  this.isAuthenticated = function () {
    return this.isLoggedIn() || !!IdentityService.getCurrentUser();
  };
  this.isGuestProfile = function () {
    return !!this.userProfile.isGuestProfile;
  };

  this.getDisplayName = function () {
    if (this.isLoggedIn()) {
      return this.userProfile.firstName + ' ' + this.userProfile.lastName;
    }
    return '';
  };

  this.getEmail = function () {
    if (this.isLoggedIn()) {
      return this.userProfile.email;
    }
    return '';
  };

  this.isLoyaltyUser = function () {
    return this.isLoggedIn() && this.userProfile.mltEnrolled;
  };

  this.getUserType = function () {
    if (this.userProfile && this.userProfile.checkUser === 'New') {
      return 'NEW';
    } else if (this.userProfile && this.userProfile.checkUser === 'Existing') {
      if (this.userProfile.isGuestProfile) {
        return 'GUEST';
      }
      if (this.userProfile.checkForEnrolled) {
        return 'LOYALTY';
      }
      return 'NONLOYALTY';
    } else {
      return null;
    }
  };

  this.userProfileStatus = function (email) {
    if (!email) {
      email = this.userProfile.email;
    }
    var deferred = $q.defer();
    $http
      .post('./userProfile/userProfileStatus', { email: email })
      .then(
        function (response) {
          if (response.data.success) {
            this.userProfile.email = email;
            this.userProfile.checkUser = response.data.check;
            this.userProfile.isGuestProfile = response.data.isGuestProfile;
            this.userProfile.checkForEnrolled = response.data.checkForEnrolledFlag;
            if (this.userProfile.checkUser !== 'Existing') {
              this.setInitialUserProfile(this.userProfile);
            }
            if (this.userProfile.isGuestProfile) {
              this.setEnrollMe(true);
            }
            deferred.resolve();
          } else {
            deferred.reject();
          }
        }.bind(this)
      )
      .catch(function (response) {
        MessageStore.createForm('COMMON_TEXT_ERROR');
        BlockService.unblockUI();

        deferred.reject(response.data);
      });
    return deferred.promise;
  };

  this.login = function (email, password) {
    BlockService.blockUI();

    const analyticsService = $injector.get('AnalyticsService');
    return $http
      .post('./userProfile/login', { email: email, password: password })
      .catch(function (e) {
        MessageStore.createForm('COMMON_TEXT_ERROR');

        throw e;
      })
      .then(({ data: response }) => {
        if (response.success) {
          analyticsService.updateContentView();

          this.guestUserProfile = {};
          this.setUserProfile({
            ...response.data.userProfile,
            isLoggedIn: true
          });

          return this.loadSubjects().then(() => this.userProfile);
        } else if (response.status === 'GUEST_PROFILE') {
          analyticsService.updateContentView();

          if (response.data) {
            this.setUserProfile({
              ...response.data.userProfile,
              isGuestProfile: true
            });

            LoginSuccessAction.dispatch();

            return this.userProfile;
          } else {
            this.userProfile.isGuestProfile = true;

            MessageStore.createForm('LOGIN_INVALID');

            throw this.userProfile;
          }
        } else {
          this.setUserProfile({});

          MessageStore.createForm('LOGIN_INVALID');

          throw this.userProfile;
        }
      })
      .finally(() => {
        $rootScope.checkIfLoggedIn = this.isLoggedIn();

        BlockService.unblockUI();
      });
  };

  this.logout = function (emailHasChanged) {
    BlockService.blockUI();

    var isLoggedInWithIdentity = this.userProfile.isLoggedInWithIdentity;
    return $http
      .get('./userProfile/logout')
      .then(function () {
        LogoutSuccessAction.dispatch();
      })
      .catch(function (response) {
        MessageStore.createSystem(response.data.error.code);
      })
      .finally(
        function () {
          if (!emailHasChanged) {
            ResetJobAction.dispatch();
          }
          this.reset();
          BlockService.unblockUI();
          // check if logged in with identity, and if they are still logged in on the identity side
          if (isLoggedInWithIdentity && !!IdentityService.getCurrentUser()) {
            IdentityService.logout();
          }
        }.bind(this)
      );
  };

  this.reloadUserProfile = function () {
    BlockService.blockUI();
    var deferred = $q.defer();
    $http
      .get('./userProfile/getUserProfile')
      .then(
        function (response) {
          if (response.data.success) {
            if (!!response.data.data) {
              this.setUserProfile(response.data.data);
              this.userProfile.isGuestProfile = response.data.data.isGuestProfile || false;
              if (this.userProfile.isGuestProfile) {
                this.userProfile.isLoggedIn = false;
              } else {
                this.userProfile.isLoggedIn = response.data.data.isLoggedIn || true;
              }
              this.userProfile.checkForEnrolled = response.checkForEnrolledFlag;
            }
            this.updateStorage();
            $rootScope.checkIfLoggedIn = this.userProfile.isLoggedIn;
            BlockService.unblockUI();

            deferred.resolve();
          } else {
            this.setUserProfile({});
            BlockService.unblockUI();

            deferred.reject(response.data.error.code);
          }
        }.bind(this)
      )
      .catch(function () {
        BlockService.unblockUI();
        MessageStore.createForm('COMMON_TEXT_ERROR');
        deferred.reject();
      });
    return deferred.promise;
  };

  this.setUserProfile = function (userProfile) {
    var wasLoggedInWithIdentity = this.userProfile.isLoggedInWithIdentity;
    var wasLoggedIn = this.userProfile.isLoggedIn;

    this.userProfile = userProfile;
    if (this.userProfile) {
      if (this.userProfile.subject && this.userProfile.subject.length > 0) {
        angular.forEach(this.userProfile.subject, function (sub) {
          if (sub.relationShip === 'NotDefined') {
            sub.relationShip = '';
          }
        });
      }
    }
    if (this.userProfile.isLoggedInWithIdentity === null || this.userProfile.isLoggedInWithIdentity === undefined) {
      this.userProfile.isLoggedInWithIdentity = wasLoggedInWithIdentity;
    }
    if (this.userProfile.isLoggedIn === null || this.userProfile.isLoggedIn === undefined) {
      this.userProfile.isLoggedIn = wasLoggedIn;
    }
    if (this.isLoyaltyUser() && !$rootScope.rewardLoaded) {
      this.loadRewards();
    }
    this.updateStorage();
    if (typeof Sentry !== 'undefined' && typeof Sentry.setUser === 'function') {
      const lifetouchUserProfileId = this.userProfile?.lifetouchUserProfileId;
      if (lifetouchUserProfileId) {
        Sentry.setUser({ id: lifetouchUserProfileId });
      }
    }
    $injector.get('HotjarSessionMappingService').identifyUser(this.userProfile?.lifetouchUserProfileId);
  };

  this.findSubject = function (userProfile, firstName, lastName) {
    var matchFound = false;
    if (userProfile) {
      if (userProfile.subject && userProfile.subject.length > 0) {
        angular.forEach(userProfile.subject, function (sub) {
          var found = false;
          found = sub.firstName === firstName && sub.lastName === lastName;

          if (found && !matchFound) {
            matchFound = found;
          }
        });
      }
    }
    if (!matchFound) {
      this.updateStorage();
    }
    return matchFound;
  };

  this.getLifetouchUserProfileId = function () {
    return this.userProfile.lifetouchUserProfileId;
  };

  this.addSubscription = function (code) {
    if (!this.userProfile.subscriptions) {
      this.userProfile.subscriptions = [];
    }

    if (!R.contains(code)(this.userProfile.subscriptions)) {
      this.userProfile.subscriptions.push(code);
      this.updateStorage();
    }
  };

  this.removeSubscription = function (code) {
    if (!!this.userProfile.subscriptions) {
      this.userProfile.subscriptions = R.filter(R.compose(R.not, R.eq(code)))(this.userProfile.subscriptions);
      this.updateStorage();
    }
  };

  this.setSubscriptions = function (subscriptions) {
    this.userProfile.subscriptions = subscriptions;
    this.updateStorage();
  };

  this.isSubscribed = function (subscriptionName) {
    var i, len;
    var subscribed = false;
    if (this.userProfile.userProfile.subscriptionOptIns) {
      for (i = 0, len = this.userProfile.userProfile.subscriptionOptIns.length; i < len; i++) {
        if (
          this.userProfile.userProfile.subscriptionOptIns[i].userSubscription === subscriptionName &&
          this.userProfile.userProfile.subscriptionOptIns[i].subscribed === true
        ) {
          subscribed = true;
        }
      }
    }
    return subscribed;
  };

  this.isSubscribed = function (userProfile, subscriptionName) {
    var i, len;
    var subscribed = false;
    if (userProfile.subscriptionOptIns) {
      for (i = 0, len = userProfile.subscriptionOptIns.length; i < len; i++) {
        if (
          userProfile.subscriptionOptIns[i].userSubscription === subscriptionName &&
          userProfile.subscriptionOptIns[i].subscribed === true
        ) {
          subscribed = true;
        }
      }
    }
    return subscribed;
  };

  this.subscribeForMyFamilyRewards = function () {
    return R.contains(this.UserSubscription.MyFamilyRewards)(this.userProfile.subscriptions || []);
  };

  this.subscribeForMyFamilyRewardsMobilePhone = function () {
    return R.contains(this.UserSubscription.MyFamilyRewardsMobilePhone)(this.userProfile.subscriptions || []);
  };

  this.updateStorage = function () {
    if (!this.userProfile.isLoggedIn) {
      StorageService.setData('userProfile', this.userProfile);
    } else {
      StorageService.setData('userProfile', {
        isLoggedIn: this.userProfile.isLoggedIn,
        isLoggedInWithIdentity: this.userProfile.isLoggedInWithIdentity
          ? this.userProfile.isLoggedInWithIdentity
          : false
      });
    }
  };

  this.scrollToLocation = function (hashToScroll) {
    $timeout(function () {
      var old = $location.hash();
      $location.hash(hashToScroll);
      // // call $anchorScroll()
      $anchorScroll();
      //reset to old to keep any additional routing logic from kicking in
      $location.hash(old);
    }, 200);
  };

  this.UserSubscription = {
    MyFamilyRewards: 'MyFamilyRewards',
    MyFamilyRewardsMobilePhone: 'MyFamilyRewardsMobilePhone'
  };

  this.createAccount = function () {
    return $http
      .post('./userProfile/create', {
        userProfile: this.userProfile,
        languageCode: TranslateProviderService.getLocale()
      })
      .then((response) => {
        const responseBody = response.data;

        if (responseBody.success) {
          StorageService.setData('token', responseBody.token);

          this.setUserProfile({
            ...responseBody.data,
            isLoggedIn: true
          });
          this.loadSubjects(false);
        } else {
          MessageStore.createForm(responseBody.error);
        }

        return response;
      })
      .catch((response) => MessageStore.createForm(response));
  };

  this.updateAccount = function (userProfile, enrollInMFR) {
    return $http
      .post('./userProfile/update', {
        userProfile: Object.assign({}, userProfile, {
          lifetouchUserProfileId: this.userProfile.lifetouchUserProfileId
        }),
        languageCode: TranslateProviderService.getLocale(),
        enrollInMFR: enrollInMFR
      })
      .then(
        function (response) {
          if (response.data.success) {
            response.data.data.isLoggedIn = true;
            this.setUserProfile(response.data.data);
            this.userProfile.subscriptions = userProfile.subscriptions;
            this.userProfile.mobile = userProfile.mobile;
            if (userProfile && !userProfile.isLoggedIn) {
              if (userProfile.email && userProfile.password) {
                this.login(userProfile.email, userProfile.password);
              }
            }
          } else {
            MessageStore.createSystem(response.data.error.code);
          }
          return response;
        }.bind(this)
      );
  };

  this.createLMIUserProfile = function () {
    $http.post('./userProfile/createLMI', {
      userProfile: this.userProfile
    });
  };

  this.changePassword = function (userProfile, enrollInMFR) {
    userProfile.subscriptionOptIns = [];
    userProfile.subscriptionAudit = { audits: [] };
    return $http
      .post('./userProfile/passwordChange', {
        userProfile: userProfile,
        languageCode: TranslateProviderService.getLocale(),
        enrollInMFR: enrollInMFR
      })
      .then(
        function (response) {
          if (response.data.success) {
            response.data.data.isLoggedIn = true;
            this.setUserProfile(response.data.data);
            if (userProfile && !userProfile.isLoggedIn) {
              if (userProfile.email && userProfile.password) {
                this.login(userProfile.email, userProfile.password);
              }
            }
          }
          return response;
        }.bind(this)
      );
  };

  this.setOptIn = function (optIn, optInFlag, subscriptionText, mobile, userProfile) {
    if (!userProfile) {
      userProfile = this.userProfile;
    }

    var backendOptIn = R.find(R.propEq('userSubscription', optIn))(userProfile.subscriptionOptIns || []);

    if (!backendOptIn) {
      var optInObj = R.find(R.propEq('subscriptionType', optIn))(userProfile.subscriptionOptIns || []);
      if (!optInObj) {
        if (!userProfile.subscriptionOptIns) {
          userProfile.subscriptionOptIns = [];
        }
        userProfile.subscriptionOptIns.push({
          subscriptionType: optIn,
          optInFlag: optInFlag,
          mobile: mobile
        });
      } else {
        optInObj.optInFlag = optInFlag;
        optInObj.mobile = mobile;
      }
    } else {
      backendOptIn.subscriptionType = '';
      backendOptIn.subscriptionType = optIn;
      backendOptIn.optInFlag = optInFlag;

      if (!!backendOptIn.phoneNumber) {
        backendOptIn.mobile = '';
        backendOptIn.mobile = mobile;
      }
    }

    var auditObj = R.find(R.propEq('subscriptionType', optIn))(
      (userProfile.subscriptionAudit && userProfile.subscriptionAudit.audits) || []
    );
    if (!auditObj) {
      if (!userProfile.subscriptionAudit || !userProfile.subscriptionAudit.audits) {
        userProfile.subscriptionAudit = { audits: [] };
      }
      userProfile.subscriptionAudit.audits.push({
        subscriptionType: optIn,
        subscriptionText: subscriptionText
      });
    } else {
      auditObj.subscriptionText = subscriptionText;
    }
  };

  this.getOptInObj = function (optIn, userProfile) {
    if (!userProfile) {
      userProfile = this.userProfile;
    }
    return R.find(R.either(R.propEq('userSubscription', optIn), R.propEq('subscriptionType', optIn)))(
      userProfile.subscriptionOptIns || []
    );
  };

  this.getPhoneNumber = function (userProfile) {
    if (!userProfile) {
      userProfile = this.userProfile;
    }
    var subscription = this.UserSubscription.MyFamilyRewardsMobilePhone;
    // when we create/update opt-ins the property is subscriptionType
    // but when whe get opt-ins the property is userSubscription :(
    var optIn = R.find(
      R.either(R.propEq('userSubscription', subscription), R.propEq('subscriptionType', subscription))
    )(userProfile.subscriptionOptIns || []);
    if (!optIn) {
      return;
    }
    return optIn.phoneNumber;
  };

  this.updateSubscriptions = function (userProfile) {
    // build optIns
    var mfrOptIn = !!R.propEq(this.UserSubscription.MyFamilyRewards, true)(userProfile.subscriptions || []);
    var mobileOptIn = !!R.propEq(
      this.UserSubscription.MyFamilyRewardsMobilePhone,
      true
    )(userProfile.subscriptions || []);
    userProfile.subscriptionOptIns = [
      {
        subscriptionType: this.UserSubscription.MyFamilyRewards,
        optInFlag: mfrOptIn,
        mobile: userProfile.mobile
      },
      {
        subscriptionType: this.UserSubscription.MyFamilyRewardsMobilePhone,
        optInFlag: mobileOptIn,
        mobile: userProfile.mobile
      }
    ];

    // build audits
    userProfile.subscriptionAudit = {
      audits: [
        {
          subscriptionType: this.UserSubscription.MyFamilyRewards,
          subscriptionText: $filter('ltTranslateFilter')('MFR_OPT_IN_MESSAGE_EMAIL', {})
        },
        {
          subscriptionType: this.UserSubscription.MyFamilyRewardsMobilePhone,
          subscriptionText: $filter('ltTranslateFilter')('MFR_OPT_IN_MESSAGE_PHONE', {})
        }
      ]
    };
  };

  this.sendPasswordResetToken = function (email) {
    return $http.post('userProfile/sendResetToken', {
      email: email,
      languageCode: TranslateProviderService.getLocale()
    });
  };

  this.clearAll = function () {
    if (!this.isLoggedIn()) {
      // user not logged in .. clear out info previously entered
      this.userProfile = {};
      this.userProfile.isLoggedIn = false;

      this.updateStorage();
    }
  };

  this.resetPassword = function (email, token, password) {
    return $http.post('userProfile/passwordUpdate', {
      email: email,
      token: token,
      password: password
    });
  };

  this.studentExists = function (subjectId, firstName, lastName) {
    var studentFound = false;
    if (this.userProfile) {
      if (this.userProfile.subject && this.userProfile.subject.length > 0) {
        R.forEach(function (student) {
          if (!studentFound) {
            studentFound =
              student.subjectId !== subjectId &&
              student.firstName.toUpperCase() === firstName.toUpperCase() &&
              student.lastName.toUpperCase() === lastName.toUpperCase();
          }
        }, this.userProfile.subject);
      }
    }
    return studentFound;
  };

  this.getSubjectIdByStudentId = function (studentId) {
    if (this.userProfile) {
      if (this.userProfile.subject && this.userProfile.subject.length > 0) {
        var student = R.find(function (subject) {
          return subject.studentId === studentId;
        }, this.userProfile.subject);
      }
    }
    return student.subjectId;
  };

  this.getStudent = function (id) {
    var x = './userProfile/getStudent/subjectId/' + id;
    return $http.get(x).then(
      function (response) {
        if (response.data.success) {
          return response.data.data;
        }
      }.bind(this)
    );
  };

  this.addStudent = function (student) {
    if (!student) {
      MessageStore.createForm('Generic_Fill_Required_Fields');
    } else {
      if (!student.lifetouchUserProfileId) {
        student.lifetouchUserProfileId = this.userProfile.lifetouchUserProfileId;
      }
      if (this.studentExists(student.subjectId, student.firstName, student.lastName)) {
        var q = $q.defer();
        q.reject('DUPLICATE_STUDENT_ERROR');
        return q.promise;
      }
      var param = angular.copy(student);
      var AnalyticsService = $injector.get('AnalyticsService');
      AnalyticsService.recordEvent(AnalyticsService.events.ADD_STUDENT);
      return $http
        .post('./userProfile/saveStudent', param)
        .then(
          function (response) {
            if (response.data.success) {
              this.reloadUserProfile();
              return response;
            } else {
              MessageStore.createForm(response.data.error);
            }
          }.bind(this)
        )
        .catch(function (error) {
          MessageStore.createForm(error ? error : 'ACCOUNT_UNKNOWN_ERROR');
        });
    }
  };

  this.updateStudent = function (student) {
    var param = angular.copy(student);
    param.lifetouchUserProfileId = this.userProfile.lifetouchUserProfileId;
    return $http
      .put('./userProfile/updateStudent', student)
      .then(
        function (response) {
          if (!response.data.success) {
            MessageStore.createSystem(response.data.error);
          }
        }.bind(this)
      )
      .catch(function (response) {
        MessageStore.createSystem(response.errorMsg);
      });
  };

  this.removeStudent = function (subjectId) {
    var url = './userProfile/deleteStudent/subjectId/' + subjectId;
    return $http
      .delete(url)
      .then(
        function (response) {
          if (!response.data.success) {
            MessageStore.createSystem(response.data.Message);
          }
        }.bind(this)
      )
      .catch(function (error) {
        MessageStore.createSystem(error.data.error.code);
      });
  };

  this.UserSubscription = {
    MyFamilyRewards: 'MyFamilyRewards',
    MyFamilyRewardsMobilePhone: 'MyFamilyRewardsMobilePhone'
  };

  this.validateOptInFlags = function (userProfile, canadianDomain) {
    var hasNoError = true;
    if (canadianDomain) {
      var isMyFamilyRewards = !!R.propEq(this.UserSubscription.MyFamilyRewards, true)(userProfile.subscriptions || []);
      if (isMyFamilyRewards && !userProfile.email) {
        MessageStore.createSystem('ACCOUNT_EMAIL_REQUIRED');
        hasNoError = false;
      }
    }
    var isMyFamilyRewardsMobile = !!R.propEq(
      this.UserSubscription.MyFamilyRewardsMobilePhone,
      true
    )(userProfile.subscriptions || []);
    if (isMyFamilyRewardsMobile && (!userProfile.mobile || userProfile.mobile.length < 10)) {
      MessageStore.createSystem('ACCOUNT_MOBILE_REQUIRED');
      hasNoError = false;
    }
    return hasNoError;
  };

  this.mobileNumberUpdate = function (userProfile) {
    var mobile = userProfile.mobile;
    if (!userProfile.subscriptions.MyFamilyRewardsMobilePhone) {
      mobile = '';
    }
    return mobile;
  };

  this.getCognitoProfileId = function () {
    if (!!this.userProfile && !!this.userProfile.cognitoProfileId) {
      return this.userProfile.cognitoProfileId;
    }
    return null;
  };

  this.addOrUpdateVerifiedSubject = function (verifiedSubject) {
    // parse verified subject to profile subject
    var parsedSubject = this.parseVerifiedSubjectToProfileSubject(verifiedSubject);
    var studentFromProfile = this.getVerifiedStudentFromProfile(parsedSubject.lifetouchId, parsedSubject.studentId);
    if (studentFromProfile) {
      parsedSubject.subjectId = studentFromProfile.subjectId;
      // Check whether verifiedSubject not similar to user profile subject
      if (this.checkIfModifiedStudentFromProfile(studentFromProfile, parsedSubject)) {
        // Update existing subject (CPS) from verified subject
        this.updateStudent(parsedSubject);
      }
    } else {
      // Add new verified subject to (CPS)
      this.addStudent(parsedSubject);
    }
  };

  this.verifyMasterSubject = function (masterSubject) {
    if (masterSubject != null && this.isLoggedIn()) {
      MasterSubjectService.verifyMasterSubject(masterSubject.ltMasterSubjectUuid);
    }
  };

  this.checkIfModifiedStudentFromProfile = function (studentFromProfile, verifiedStudent) {
    return !(
      studentFromProfile.firstName.toLowerCase() === verifiedStudent.firstName.toLowerCase() &&
      studentFromProfile.lastName.toLowerCase() === verifiedStudent.lastName.toLowerCase() &&
      !!studentFromProfile.relationShip &&
      !!verifiedStudent.relationShip &&
      studentFromProfile.relationShip === verifiedStudent.relationShip &&
      !!studentFromProfile.grade &&
      !!verifiedStudent.grade &&
      studentFromProfile.grade.toLowerCase() === verifiedStudent.grade.toLowerCase()
    );
  };

  this.checkIfModifiedVerifiedStudentsFromProfile = function (studentFromProfile, verifiedStudent) {
    return !(
      studentFromProfile.firstName.toLowerCase() === verifiedStudent.subjectFirstName.toLowerCase() &&
      studentFromProfile.lastName.toLowerCase() === verifiedStudent.subjectLastName.toLowerCase() &&
      !!studentFromProfile.relationShip &&
      !!verifiedStudent.subjectRelationship &&
      studentFromProfile.relationShip === verifiedStudent.subjectRelationship &&
      !!studentFromProfile.grade &&
      !!verifiedStudent.subjectGrade &&
      studentFromProfile.grade.toLowerCase() === verifiedStudent.subjectGrade.toLowerCase()
    );
  };

  this.getVerifiedStudentFromProfile = function (lifetouchId, studentId) {
    if (this.userProfile && this.userProfile.subject && this.userProfile.subject.length > 0) {
      return R.find(function (subject) {
        return (
          subject.lid.toString() === lifetouchId.toString() && subject.studentId.toString() === studentId.toString()
        );
      })(this.userProfile.subject);
    }
  };

  this.parseVerifiedSubjectToProfileSubject = function (verifiedSubject) {
    var GradeService = $injector.get('GradeService');
    var subjectDetails = {
      firstName: verifiedSubject.subjectFirstName,
      lastName: verifiedSubject.subjectLastName,
      middleName: '',
      currentSchool: verifiedSubject.account.accountAlias,
      schoolState: verifiedSubject.account.state.name,
      schoolCity: verifiedSubject.account.city,
      gender: '',
      grade: GradeService.getNoGrade(),
      relationShip: verifiedSubject.subjectRelationship,
      lifetouchId: verifiedSubject.lifetouchId.toString(),
      lifetouchUserProfileId: this.getLifetouchUserProfileId(),
      studentId: verifiedSubject.studentId,
      subjectId: ''
    };
    return subjectDetails;
  };

  this.addOrUpdateStudentsToProfile = function (verifiedSubjects) {
    var subjectsList = [];
    var GradeService = $injector.get('GradeService');
    var deferred = $q.defer();
    angular.forEach(verifiedSubjects, function (verifiedSubject) {
      var subject = {
        subjectFirstName: verifiedSubject.subjectFirstName,
        subjectLastName: verifiedSubject.subjectLastName,
        subjectMiddleName: '',
        subjectSchool: verifiedSubject.account.accountAlias,
        subjectState: verifiedSubject.account.state.name,
        subjectCity: verifiedSubject.account.city,
        subjectGender: '',
        subjectGrade: GradeService.getNoGrade(),
        subjectRelationship: verifiedSubject.subjectRelationship,
        lifetouchId: verifiedSubject.lifetouchId.toString(),
        lifetouchUserProfileId: that.getLifetouchUserProfileId(),
        studentId: verifiedSubject.studentId,
        subjectId: ''
      };
      var studentFromProfile = that.getVerifiedStudentFromProfile(
        verifiedSubject.lifetouchId.toString(),
        verifiedSubject.studentId
      );
      if (studentFromProfile) {
        subject.subjectId = studentFromProfile.subjectId;
        if (that.checkIfModifiedVerifiedStudentsFromProfile(studentFromProfile, subject)) {
          subjectsList.push(subject);
        }
      } else {
        subjectsList.push(subject);
      }
    });

    if (subjectsList.length > 0) {
      var userProfile = {
        subjectDetails: subjectsList
      };
      return this.updateAccount(userProfile, false).then(
        function () {
          this.reloadUserProfile();
        }.bind(this)
      );
    } else {
      deferred.resolve();
      return deferred.promise;
    }
  };

  this.loadSubjects = (includePersistentCart = true) =>
    Promise.allSettled([this.loadMasterSubjects(), includePersistentCart ? PersistentCartService.load() : $q.resolve()])
      .then((results) => {
        if (results.some((result) => result.status === 'rejected')) {
          SubjectStore.subjectsLoadingFailure();
        } else {
          SubjectStore.subjectsLoadingSuccess();
        }
      })
      .finally(() => {
        $rootScope.checkIfLoggedIn = this.isLoggedIn();
        SubjectStore.sortVerifiedSubject();
      });

  this.loadMasterSubjects = () => {
    return SubjectStore.loadMasterSubjects().then((data) => {
      if (data?.error === 'NOT_FOUND') {
        this.createLMIUserProfile();
      }
    });
  };

  this.isTestingUser = function () {
    return !!this.userProfile.isTestingUser;
  };

  this.onDeserialized = function (type, data) {
    if (!!data && !!data.userProfile) {
      this.userProfile = data.userProfile;
    }
  };

  DeserializeAction.register(this.onDeserialized.bind(this));
  ResetJobAction.register(this.clearAll.bind(this));

  SessionTimeoutAction.register(
    function () {
      this.reset();
    }.bind(this)
  );
}

App.service('UserProfileStore', [
  '$http',
  'BlockService',
  'MessageStore',
  'RewardStore',
  'LoginSuccessAction',
  'DeserializeAction',
  'ResetJobAction',
  'StorageService',
  'TranslateProviderService',
  'LogoutSuccessAction',
  'JobLoadedAction',
  'SessionTimeoutAction',
  '$q',
  '$rootScope',
  '$timeout',
  'JobStore',
  '$anchorScroll',
  '$location',
  '$filter',
  '$injector',
  'IdentityService',
  'SubjectStore',
  'MasterSubjectService',
  'PersistentCartService',
  UserProfileStore
]);

App.run([
  'UserProfileStore',
  function (UserProfileStore) {
    // eagerly initialize the store so that event listeners are registered
  }
]);
